import * as React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Button,
  DialogTitle,
  Typography,
} from "@mui/material";
import { CareersUseStyles } from "./style";

const ViewEvent = (props) => {
  const classes = CareersUseStyles();
  let { open, handleClose, description, position_name, department_name } =
    props;
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle className={classes.eventTitle}>{position_name}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography className={classes.eventName}>
              {department_name}
            </Typography>
            <Typography>{description}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.eventName}>
              {department_name}
            </Typography>
            <Typography>{description}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewEvent;
